import './GearLinkSection.scss';

import { Link } from 'react-router-dom';
import { SettingOutlined } from '@ant-design/icons';

import React, { PropsWithChildren } from 'react';

export interface GearLinkSectionProps {
	route?: string;
}

export const GearLinkSection: React.FC<PropsWithChildren<GearLinkSectionProps>> = ({ children, route }) =>
	<div className='gear-link-section'>
		{ children }
		<Link to={ route ?? '' }>
			<SettingOutlined />
		</Link>
	</div>;
